// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { ErrorMessage } from "@outschool/ui-components-shared";
export enum ErrorQueryParam {
  EducatorsOnlyPage = "educators-only",
}
export default ErrorMessage;
